import { IsString, IsOptional, MaxLength } from 'class-validator';

export class CannedResponseSearchDTO {

    @IsOptional()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    content: string;

}
